<template>
  <div class="app-container mechanismHallDetail">
    <el-card>
      <div class="detail">
        <div class="examineDetailInfo">
          <div class="avatarCon">
            <div class="tooltipText">
              <span><i class="el-icon-caret-bottom"></i>提交</span>
            </div>
            <el-avatar :size="size" :src="circleUrl">
              <i class="el-icon-s-custom"></i>
            </el-avatar>
            <div class="name">{{ examineDetail.createUser }}</div>
            <div class="time">{{ examineDetail.createTime }}</div>
          </div>
          <div class="plan">
            <div style="text-align: center; color: #fff">
              {{ '共耗时：' + examineDetail.timeLimit }}
            </div>
            <el-progress :show-tooltip="true" :percentage="examineDetail.examineStatus == 1 ? 50 : 100"
              :color="examineStatus.tipColor" stroke-width="4" />
          </div>
          <div class="avatarCon">
            <div class="tooltipText">
              <span :style="'background-color:' + examineStatus.tipColor"><i class="el-icon-caret-bottom"
                  :style="'color:' + examineStatus.tipColor"></i>
                {{ examineStatus.tipTitel }}</span>
            </div>
            <el-avatar :size="size" :src="circleUrl">
              <i class="el-icon-s-custom"></i>
            </el-avatar>
            <div v-if="examineDetail.examineStatus != 1">
              <div class="name">{{ examineDetail.examineUser }}</div>
              <div class="time">{{ examineDetail.examineTime }}</div>
            </div>
          </div>
        </div>
        <div class="hallDetail">
          <div class="hallMainTitle">
            <strong>机构详情</strong>
            <div class="btnBox" v-if="examineDetail.examineStatus == 1">
              <el-button type="primary" @click="btnOperation('approved')">
                <i class="el-icon-check"></i>审批通过
              </el-button>
              <el-button type="danger" @click="btnOperation('refuse')" class="refuse" style="margin-left: 10px;" plain>
                <i class="el-icon-close"></i>审批拒绝
              </el-button>
            </div>
          </div>
          <div style="padding: 15px;">
            <div class="ant-descriptions-header">
              <div class="ant-descriptions-title">
                <span style="color: #1890FF">▋</span>
                场馆信息
              </div>
            </div>
            <el-descriptions title="" direction="vertical" :column="4" border>
              <el-descriptions-item width="" label="机构名称">{{ hallDetail.name || '-' }}</el-descriptions-item>
              <el-descriptions-item label="社会信用代码/注册号">{{ hallDetail.socialCreditCode || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所在地区">{{ hallDetail.addressName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="详细地址">{{ hallDetail.detailAddress || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所属体育局">{{ hallDetail.organizationName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="营业执照">
                <!-- {{ hallDetail.businessLicenseUrl }} -->
                <el-image
              v-if="hallDetail.businessLicenseUrl"
              style="width: 100px; height: 100px"
              :src="hallDetail.businessLicenseUrl"
              :preview-src-list="srcList"
              :fit="fit"></el-image>
              <el-image v-else>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              </el-descriptions-item>
              <el-descriptions-item label="法人姓名">{{ hallDetail.legalPersonName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="法人身份证号码">{{ hallDetail.legalPersonIdNo || '-' }}</el-descriptions-item>

              <el-descriptions-item label="联系人">{{ hallDetail.contactsName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ hallDetail.contactsPhone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="入驻说明">{{ hallDetail.explain || '-' }}</el-descriptions-item>
              <el-descriptions-item label=""></el-descriptions-item>
            </el-descriptions>

            <!-- 操作记录 -->
            <div class="operationRecord">
              <div class="ant-descriptions-header">
                <div class="ant-descriptions-title">
                  <span style="color: #1890FF">▋</span>
                  操作记录
                </div>
              </div>

              <el-timeline class="timeLineBox">
                <el-timeline-item placement="top" v-for="(item, index) in operationRecord" :key="index">
                  <el-card>
                    <div class="timeLine">
                      <strong>{{ item.operationUserName }}</strong>
                      <p v-show="item.operationType == 0">
                        发起审批<span class="recordTime">
                          <i class="el-icon-time"></i>{{ item.operationTime }}
                        </span>
                      </p>
                      <p v-show="item.operationType == 1">
                        待审批
                      </p>
                      <p v-show="item.operationType == 2">
                        通过<span class="recordTime">
                          <i class="el-icon-time"></i>{{ item.operationTime }}
                        </span>
                      </p>
                      <p v-show="item.operationType == 3">
                        拒绝<span class="recordTime">
                          <i class="el-icon-time"></i>{{ item.operationTime }}
                        </span>
                      </p>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>

            </div>
          </div>

        </div>

      </div>
    </el-card>

    <!-- 审批(通过/拒绝)mode -->
    <a-modal v-model:visible="showApproved" :title="operationType == 'refuse' ? '审批拒绝' : '审批通过'"
             @ok="approved(operationType)" autocomplete="off" centered width="600px">
      <a-form ref="approvedRuls" :model="approvedForm" :rules="approvedRules">
        <a-form-item v-if="operationType != 'refuse'" label="有效期" name="validityPeriod">
          <a-date-picker
            v-model:value="approvedForm.startTime"
            type="datetime"
            placeholder="开始日期"
            :disabled-date="startDisabledDate"            style="width: 48%; margin-right: 4%;">
          </a-date-picker>
          <a-date-picker
            v-model:value="approvedForm.endTime"
            type="datetime"
            placeholder="结束日期"
            :disabled-date="endDisabledDate"            style="width: 48%;">
          </a-date-picker>
        </a-form-item>
        <a-form-item label="备注信息" has-feedback :rules="[
              {
                required: operationType == 'refuse' ? true : false,
                message: '请填写拒绝原因!',
              },
            ]">
          <a-textarea :placeholder="operationType == 'refuse' ? '请填写拒绝原因！' : '请填写备注信息'" v-model:value="approvedForm.remark"
                      show-count :maxlength="200" :rows="4" />
        </a-form-item>
        <span v-show="operationType == 'refuse'" style="color: #F56C6C;">拒绝入驻，需要填写拒绝原因</span>
      </a-form>
    </a-modal>

  </div>
</template>
<script>
import moment from "moment";
import { Switch } from "ant-design-vue";
import * as API_Mechanism from "@/api/system/mechanism";
export default {
  name: "hallDetail",
  data() {
    return {
      id: this.$route.query.id,
      detailId: "",
      examineDetail: "", //审批信息
      examineStatus: {
        //状态
        tipTitel: "",
        tipColor: "",
        lineColor: "",
      }, //审批状态1待审2通过3拒绝
      hallDetail: "", //场馆详情信息
      operationRecord: [], //操作记录
      srcList: [],
      showApproved: false,
      approvedNote: "", //审批备注
      operationType: "",
      approvedForm: {
        startTime: null, //有效期开始时间
        endTime: null, //有效期结束时间
        remark: "", //审批备注
      },
      approvedRules: {
        validityPeriod: [
          {
            validator: (rule, value, callback) => {
              if (this.operationType == 'refuse') {
                callback();
                return;
              }
              if (!this.approvedForm.startTime || !this.approvedForm.endTime) {
                callback(new Error('请选择有效期'));
                return;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  mounted() {
    this.detailId = this.$route.query.id;
    this.getHallDetail();
  },
  methods: {

    btnOperation(type) {
      console.log('typetype')
      console.log(type)
      this.operationType = type;
      this.approvedNote = ''
      this.approvedForm = {
        startTime: null,
        endTime: null,
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.approvedRuls && this.$refs.approvedRuls.clearValidate();
      });
      this.showApproved = true;
    },

    //审批或拒绝场馆入驻
    approved(type) {
      let examineStatus = 2;
      //审批状态
      if (type == "refuse") {
        examineStatus = 3;
      }
      if (type == "refuse" && this.approvedNote.length < 1) {
        this.$message.error('请填写拒绝原因')
        return;
      }
      let param = [];
      let baseParam = {
        examineStatus: examineStatus, //审批状态2通过3拒绝
        remark: this.approvedForm.remark, //备注
      };
      //审批通过时附带有效期时间戳
      if (type == "approved") {
        baseParam.startTime = this.approvedForm.startTime
          ? new Date(this.approvedForm.startTime).getTime()
          : null;
        baseParam.endTime = this.approvedForm.endTime
          ? new Date(this.approvedForm.endTime).getTime()
          : null;
      }
      param[0] = {
        ...baseParam,
        hallId: this.id, //场馆id
      };
      API_Mechanism.batchApproval(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          this.getHallDetail();
          this.showApproved = false;
          this.$message.success('操作成功')
        }
      });
    },

    // 机构详情信息
    getHallDetail() {
      let _that = this;
      let param = {
        id: _that.detailId, //场馆id
      };

      API_Mechanism.hallDetail(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          let data = res.data;
          if (data.operationRecord && data.operationRecord.length > 0) {
            data.operationRecord.forEach((el) => {
              el.operationTime = moment(el.operationTime).format(
                "YYYY-MM-DD HH:mm:ss",
              );
            });
          }
          if (data.examineDetail) {
            //审批状态1待审2通过3拒绝
            switch (data.examineDetail.examineStatus) {
              case 1:
                _that.examineStatus = {
                  tipTitel: "待审批",
                  tipColor: "#1890FF"
                };
                break;
              case 2:
                _that.examineStatus = {
                  tipTitel: "已通过",
                  tipColor: "#67C23A"
                };
                break;
              case 3:
                _that.examineStatus = {
                  tipTitel: "已拒绝",
                  tipColor: "#F56C6C"
                };
                break;
              default:
                break;
            }
            let createTime = data.examineDetail.createTime;
            data.examineDetail.createTime = moment(createTime).format(
              "YYYY-MM-DD HH:mm:ss",
            );
            let examineTime = data.examineDetail.examineTime;
            data.examineDetail.examineTime = moment(examineTime).format(
              "YYYY-MM-DD HH:mm:ss",
            );
          }
          try {
            data.hallDetail.address = JSON.parse(data.hallDetail.address).label;
            //1天2周3月4年
            switch (data.hallDetail.openTimeMetric) {
              case 1:
                data.hallDetail.openTimeMetric = "天";
                break;
              case 2:
                data.hallDetail.openTimeMetric = "周";
                break;
              case 3:
                data.hallDetail.openTimeMetric = "月";
                break;
              case 4:
                data.hallDetail.openTimeMetric = "年";
                break;
            }
          } catch (e) { }
          _that.examineDetail = data.examineDetail;
          _that.hallDetail = data.hallDetail;
          _that.operationRecord = data.operationRecord;
          if (data.hallDetail.businessLicenseUrl) {
            console.log('走进来了')
            _that.srcList.push(data.hallDetail.businessLicenseUrl)
          }
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.hallDetail {
  border: 1px solid rgba(255, 255, 255, .05);
  margin-top: 30px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .hallMainTitle {
    background-color: #21284B;
    height: 60px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: space-between;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;

    .btnBox {
      i {
        margin-right: 5px;
      }
    }
  }

  .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
    background-color: transparent;
  }

  ::v-deep .el-descriptions__body {
    background-color: rgba(255, 255, 255, .1);
  }

  ::v-deep .el-descriptions {
    .el-descriptions-row {
      th {
        background-color: #21284b;
        color: #BCBCBC;
        font-weight: bold;
        font-size: 14px;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 30%;
      }

      th:nth-child(3) {
        width: 30%;
      }

      th:nth-child(4) {
        width: 20%;
      }
      td {
        background-color: #141937;
        color: #fff;
        line-height: 22px;
        font-size: 12px;
      }
    }
  }
}



// 进度审核信息
.examineDetailInfo {
  width: 100%;
  display: flex;
  border: 1px solid rgba(255, 255, 255, .05);
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;

  .plan {
    flex: 1;
    width: 100%;
    margin-top: 28px;
    padding: 0 15px;
    box-sizing: border-box;

    ::v-deep .el-progress-bar {
      padding-right: 0;
      margin-right: 0;
    }

    ::v-deep .el-progress__text {
      display: none !important;
    }
  }

  .avatarCon {
    text-align: center;

    .el-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-bottom: 8px;
      background: rgba(255, 255, 255, .5);
      color: #141937;

      i.el-icon-s-custom {
        font-size: 20px;
      }
    }

    .tooltipText {
      width: 70px;
      margin: 0 auto;
      margin-bottom: 10px;

      span {
        background-color: #1890FF;
        color: #fff;
        width: 70px;
        height: 26px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        position: relative;
        z-index: 2;

        i {
          position: absolute;
          left: 50%;
          margin-left: -7px;
          bottom: -10px;
          font-size: 16px;
          color: #1890FF;
        }
      }

    }

    .name {
      color: #fff;
      margin-bottom: 4px;
      font-size: 14px;
    }

    .time {
      color: #999;
      font-size: 12px;
    }
  }

}

/*场馆操作记录*/
.operationRecord {
  margin-top: 30px;

  ::v-deep .el-timeline-item__tail {
    border-left: 2px solid #8a8c9b;
  }

  ::v-deep .el-timeline-item__node {
    background-color: #8a8c9b;
  }
}

:deep.ant-descriptions-view {
  margin-top: 2%;
}

.ant-tooltip {
  position: fixed !important;
}

:deep(.ant-descriptions-view .ant-descriptions-item-content) {
  color: #999 !important;
}

:deep(.detail .ant-descriptions-title) {
  margin-top: 20px !important;
}

.ant-descriptions-title {
  color: #fff;
  margin-top: 20px;
  margin-bottom: 10px;
}

::v-deep .timeLineBox {
  .el-timeline-item__content {
    .el-card {
      border: 1px solid rgba(255, 255, 255, .05);

      .el-card__body {
        padding: 15px;

        .timeLine {
          strong {
            margin-bottom: 5px;
            width: 100%;
            display: inline-block;
          }

          p {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #999;

            i {
              margin-right: 3px;
            }
          }
        }
      }
    }
  }

  .el-timeline-item {
    .el-timeline-item__tail {
      margin-top: 30px;
    }

    .el-timeline-item__node--normal {
      margin-top: 30px;
    }
  }
}
</style>
